export type HelpdeskSeverity = "Low" | "Medium" | "High" | "Critical";

export const HELPDESK_SEVERITY_OPTIONS: HelpdeskSeverity[] = [
  "Low",
  "Medium",
  "High",
  "Critical",
];
